import React from 'react';
import { COLORS, RADIUS } from './tokens';

/*
 * FilterCard — the box that holds a report's selectors (shop, warehouse, From / To week, View).
 * The same white card the grids and forms use, so a report reads as headline → filters → results
 * instead of controls floating on the page. Layout inside is the report's own Row, unchanged.
 */
export default function FilterCard({ children, style }) {
    return (
        <div style={{
            background: COLORS.surface, border: `1px solid ${COLORS.border}`, borderRadius: RADIUS.card,
            padding: '16px 16px 4px', marginBottom: 20, ...style,
        }}>
            {children}
        </div>
    );
}
